/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React__default from 'react';
import cx from 'classnames';
import { usePrefix } from '../../internal/usePrefix.js';

const FluidMultiSelectSkeleton = _ref => {
  let {
    className,
    ...rest
  } = _ref;
  const prefix = usePrefix();
  const wrapperClasses = cx(className, `${prefix}--list-box__wrapper--fluid`);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: wrapperClasses
  }, rest), /*#__PURE__*/React__default.createElement("div", {
    className: `${prefix}--skeleton ${prefix}--list-box`
  }, /*#__PURE__*/React__default.createElement("span", {
    className: `${prefix}--list-box__label`
  }), /*#__PURE__*/React__default.createElement("div", {
    className: `${prefix}--list-box__field`
  })));
};
FluidMultiSelectSkeleton.propTypes = {
  /**
   * Specify an optional className to add.
   */
  className: PropTypes.string
};

export { FluidMultiSelectSkeleton as default };
